<template>
    <div>
          <div class="pop_search_bg bgf7 w900" >
            <div class="input-group-02">
              <div class="colum-02 col-4">
                <div class="form_box-02">
                  <label for="code">차대번호</label>
                  <input type="text" id="code" class="input-text" placeholder="차대번호를 입력해주세요" value="" autocomplete="off"
                        v-model.lazy.trim="this.grid_options.general.params.vehicleId">
                </div>
              </div>
              <div class="colum-02 col-1">
                <div class="form_group">
                  <a href="javascript:void(0);" v-on:click="getDetailCarModel" class="account_btn" >조회</a>
                </div>
              </div>
            </div>
          </div>
          <!-- 검색 결과 부분 -->
          <div class="product_sh_result">
            <div class="sub_left_wrap">
              <span>{{this.carName}}</span>
            </div>
            <div class="sub_right_wrap">
              <div class="btn_area pt0">
                <a href="javascript:void(0);" class="button white" v-on:click="openCarModelViewPopup"><span class="fz13">차량모델 보기</span></a>
              </div>
            </div>
          </div>
          <carModelViewPopup v-model="carModelCode"/>
    </div>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'
import CarModelViewPopup from '../../common/CarModelViewPopup.vue'

export default {
    name : 'tabCarVin',
    components : { Grid, GridModule, Vue, CarModelViewPopup },
    props : {
        value : '',
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            pushToParent: '', //자식이 부모창으로 전달
            carName: '',
            carModelCode : '',
            selectBox_options : {
                brandCodeVo : ''
            },
            // 또는 pushToParent: {
            //   data1: '',
            //   data2: '',
            //   data3: ''
            // },
            grid_options : {
                general : {
                id  : 'brand-popup-grid',
                search : '/brand/list',
                // update : '/brand/update',
                //   excel : {
                //     url : '/brand/excel.xls',
                //     fileName : 'brandPopupList'
                //   },
                type : {
                    isUpdate : false,
                    //isHideAdd : true : true,
                },
                PageInfo : {
                },
                params : {
                    vehicleId: ''
                }              
                },
                grid_options : {
                    height: 400,
                paging: {
                    pagerTotal : false,
                    hidePageList : true,
                    pagerSelect : false
                },
                    columnMapping : [
                        //{   key : 'brandId',          hidden: true },
                        {   width : '30px',            selectorColumn : true   },
                        {   key : 'brandNo',        title : '로고',   width : '150px' }, 
                        {   key : 'brandId',        title : '구분',   width : '138px' }, 
                        {   key : 'brandName',        title : 'SKN 상품코드',   width : '200px' }, 
                        {   key : 'brandEngNamePrefix',    title : '안성물류',   width : '100px' }, 
                        {   key : 'discountRate',     title : '서울물류',       width : '100px' },
                        {   key : 'discountRate',     title : '일반단가',       width : '100px',    align : 'right' },
                        {   key : 'discountRate',     title : '호환상품',       width : '80px' }
                    ]
                }
            }
        }
    },
    created() {
        this.carName = '';

    },
    mounted () {

    },
    methods : {
        getDetailCarModel() {
        //   let serverPageInfo = { current :  1, perPage : 9999};
        //   Vue.httpClient
        //   .get('/brand/list', {params : serverPageInfo})
        //   .then((result) => {
        //     if ( result.data.result ) {
        //       this.gridTotal = result.data.result.total;
        //     }
        //   })
            this.carName = '임의로 BMW 컨버터블 세팅';
        },
        openCarModelViewPopup() {
          this.$modal.show('carModelViewPopup', {});
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/views/common/partsCodeSearch/TabCarVin.vue